import React, {forwardRef} from 'react';

import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "./widget-wrapper.module.scss";
import {WidgetWrapperTitle} from "./widget-wrapper.title";

export const WidgetWrapper = observer(forwardRef( ({
                                                                                         children,
                                                                                         controller,
                                                                                         title,
                                                                                         className,
                                                                                         bookmaker,
                                                                                         ElementComponent,
                                                                                         source,
                                                                                         sportTypeId,
                                                                                         titleTag,
                                                                                         shouldRenderWrapper = true
                                                                                       }, ref) => {
  const titleProps = {
    controller,
    bookmaker,
    ElementComponent,
    title,
    source,
    sportTypeId,
    titleTag,
    currentLinkModel: controller?.state.currentLinkModel
  }

  return (
      shouldRenderWrapper ? <div className={classNames(className, styles.container)} id={controller?.config?.name || undefined} ref={ref}>
      <WidgetWrapperTitle {...titleProps}/>
      {children}
      </div> : <div className={classNames(className, styles.container)} id={controller?.config?.name || undefined} ref={ref}>{children}</div>
  );
}));
